import { NgModule } from "@angular/core";
import { PricewatchAddModalComponent } from "./components/pricewatch-add-modal.component";
import { CoreModule } from "../../../core/core.module";

const components = [PricewatchAddModalComponent];

@NgModule({
	imports: [CoreModule],
	declarations: [...components],
	exports: [...components]
})
export class PricewatchAddModule {}
